
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BankAccount {
    NroIdentificadorCuentaBanco: string;
    CodIdentificador: string;
    Banco_ID: string;
    TipoCuentaBanco: string;
    NoCuenta: string;
    Descripcion: string;
    CodMoneda: string;
    CuentaInterBancaria: string;
    NoCuentaCargo: string;
    Activo: boolean | number;
    Predeterminado: boolean | number;
    IBAN?: string;
    BBAN?: string;
    EMailUsuario?: string;
}

interface Bank {
    Banco_ID: string;
    Descripcion: string;
}

interface Currency {
    CodMoneda: string;
    Descripcion: string;
}

interface BankState {
    configEnabled: boolean;
    accounts: BankAccount[];
    banks: Bank[];
    currencies: Currency[];
    loading: boolean;
    operationSuccess: boolean | null;
    operationMsg: string;
}

const initialState: BankState = {
    configEnabled: false,
    accounts: [],
    banks: [],
    currencies: [],
    loading: false,
    operationSuccess: null,
    operationMsg: '',
};

export const bankSlice = createSlice({
    name: 'bank',
    initialState,
    reducers: {
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setBankConfig: (state, action: PayloadAction<any[]>) => {
            console.log('TODO: setBankConfig', action.payload)
            // state.configEnabled = true;
            if (action.payload?.length) {
                state.configEnabled = !!action.payload[0].PermitirEdicionCuentaBancarias;
            } else {
                state.configEnabled = false;
            }
        },
        setBankAccounts: (state, action: PayloadAction<any[]>) => {
            state.accounts = action.payload || [];
        },
        setBanksList: (state, action: PayloadAction<any[]>) => {
            state.banks = action.payload || [];
        },
        setCurrenciesList: (state, action: PayloadAction<any[]>) => {
            state.currencies = action.payload || [];
        },
        setOperationResult: (state, action: PayloadAction<{ success: boolean, msg: string }>) => {
            state.operationSuccess = action.payload.success;
            state.operationMsg = action.payload.msg;
        },
        resetOperationState: (state) => {
            state.operationSuccess = null;
            state.operationMsg = '';
        }
    }
});

export const {
    setLoading,
    setBankConfig,
    setBankAccounts,
    setBanksList,
    setCurrenciesList,
    setOperationResult,
    resetOperationState
} = bankSlice.actions;

export default bankSlice.reducer;
